<template>
	<div style="width: 100%;height: 100%;">
		<div style="width:99%;margin-left: 1%;margin-top:1.5%;height:95%;background-color: white;box-shadow:#e0e0e0 5px 5px 10px;overflow-y: auto;overflow-x: hidden;">
			<div style="width:95%;height:96%;padding:2%;display: flex;flex-direction: column;">
                <div style="height: auto;width: 80vw;border-radius: 0px;background-color:rgba(180,255,255,0.3);margin-top: 2vh;display: flex;flex-wrap: wrap;;padding:10px;
			justify-content: space-between;
			">
			<div style="width: 13.5%;height: 11vh;border-radius: 0px;position: relative;" :style="{marginRight:true?'-3px':'0',marginTop:(isLiving&&item.frame==true)?'2px':'5px',marginBottom:(isLiving&&item.frame==true)?'2px':'5px',color:getcolor1(item.status,item.type),border:(!isLiving&&item.frame==true)?('2px solid '+getcolor1(item.status,item.type)):''}"
			v-for="(item,index) in list" @click="update1(item)" 
			:key="index"
			>
				<div style="width: 100%;height: 100%;position: relative;overflow: hidden;z-index: 2;background-color: white;">
					<div style="width: 95%;height:95%;padding:2.5%;display: flex;flex-direction: column;z-index: 9;position: relative;" >
						<div style="font-size: 1.5vh;margin-bottom: 2px;margin-top: 0px;"  v-if="item.time==null" >{{item.date+"/"+item.week}}</div>
						<div style="display: flex;flex-direction: row;align-items: center;justify-content: space-between;margin-top: 0px;" v-else>
							<div style="font-size: 1.4vh;margin-bottom: 2px;margin-top: 0px;" :style="{marginTop:(item.time.indexOf('\n')!=-1)?'-1.7vh':'0px'}">{{item.date+"/"+item.week}}</div>
							<div style="font-size: 1.4vh;margin-bottom: 2px;margin-top: 0px;" v-html='item.time.replace("\n","<br>")'></div>
						</div>
						<div v-if="item.status==1" style="font-size: 1.8vh;" :style="{marginTop:(juge2(item.type)?'-1.7vh':'0vh')}">{{item.title==null?(gettype(item.type)):item.title}}</div>
						<div v-if="item.status==0" style="font-size: 1.8vh;margin-top: 0px;margin-bottom: 0px;">{{'休息日'}}</div>
						<div v-if="item.status==-1" style="font-size: 1.8vh;margin-top: 0px;margin-bottom: 0px;">{{'待定'}}</div>
						<div v-if="item.status==1" style="font-size: 1.6vh;margin-top: 0px;" v-html='item.data.replace("\n","<br>")'></div>					
					</div>
					<div style="width: 100%;height: 100%;position: absolute;z-index: 2;top:0;left:0;opacity: 0.8;" :style="{background:getcolor(item.status,item.type)}">
						
					</div>
					<div style="width: 100%;height: 100%;opacity: 0.2;position: absolute;top:0;left:0;z-index: 1;display: flex;align-items: center;justify-content: center;overflow: hidden;"
					
					>
						<div v-if="juge2(item.type)&&item.image.indexOf(';')!=-1" style="width: 100%;height: 100%;position: relative;overflow: hidden;">
						    <!-- 左半部分梯形图片 -->
						    <img 
						        style="width: 100%;height: 100%;position: absolute;;object-fit: cover;
						               clip-path: polygon(0 0, 100% 0, 50% 100%, 0 100%);" 
                                referrerpolicy="no-referrer"
						        :src="item.image.split(';')[0]" />
						    <!-- 右半部分梯形图片 -->
						    <img 
						        style="width: 70%;height: 100%;position: absolute;right:0;;object-fit: cover;
						               clip-path: polygon(50% 0, 100% 0, 100% 100%, 0 100%);" 
                                referrerpolicy="no-referrer"
						        :src="item.image.split(';')[1]" />
						    
						</div>
						    
						<img v-else style="width: 100%;height: 100%;object-fit: cover;" referrerpolicy="no-referrer" :src="getimage(item)" />
					</div>
				</div>	

			</div>

			
		</div>
            </div>
        </div>
        <el-dialog
            :title="info.date"
            :visible.sync="show"
            width="40%"
            >
            <div>
                <el-form ref="info" :model="info" label-width="120px">
                     <el-form-item label="当日安排">
                        <el-radio-group v-model="type" @input="change">
                            <el-radio :label="0">待定</el-radio>
                            <el-radio :label="1">休息</el-radio>
                            <el-radio :label="2">单播</el-radio>
                            <el-radio :label="3">双播</el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item label="第一场直播类型" v-if="type>=2">
                        <el-radio-group v-model="type1" >
                            <el-radio :label="0">杂谈</el-radio>
                            <el-radio :label="1">歌回</el-radio>
                            <el-radio :label="2">游戏回</el-radio>
                            <el-radio :label="3">水友回</el-radio>
                            <el-radio :label="4">DD歌回</el-radio>
                            <el-radio :label="5">联动回</el-radio>
                            <el-radio :label="6">二创回</el-radio>
                            <el-radio :label="7">其他</el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item label="第一场直播标题" v-if="type>=2">
                        <el-input v-model="info.list[0].data" ></el-input>
                    </el-form-item>
                    <el-form-item label="第一场直播时间" v-if="type>=2">
                        <el-input v-model="info.list[0].time" placeholder="xx:xx-xx:xx"></el-input>
                    </el-form-item>
                    <el-form-item label="封面" v-if="type>=2">
                        <el-upload
                            class="avatar-uploader"
                            action="/api/admin/uploadimage"
                            :data="{type:1}"
                            :on-success="handleAvatarSuccess1"
                            :show-file-list="false">
                                <img v-if="info.list[0].image!=null&&info.list[0].image!=''" :src="info.list[0].image" referrerpolicy="no-referrer" class="avatar">
                                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                        </el-upload>
                    </el-form-item>
                    <el-form-item label="第二场直播类型" v-if="info.double">
                        <el-radio-group v-model="type2" >
                            <el-radio :label="0">杂谈</el-radio>
                            <el-radio :label="1">歌回</el-radio>
                            <el-radio :label="2">游戏回</el-radio>
                            <el-radio :label="3">水友回</el-radio>
                            <el-radio :label="4">DD歌回</el-radio>
                            <el-radio :label="5">联动回</el-radio>
                            <el-radio :label="6">二创回</el-radio>
                            <el-radio :label="7">其他</el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item label="第二场直播标题" v-if="info.double">
                        <el-input v-model="info.list[1].data" placeholder=""></el-input>
                    </el-form-item>
                    <el-form-item label="第二场直播时间" v-if="info.double">
                        <el-input v-model="info.list[1].time" placeholder="xx:xx-xx:xx"></el-input>
                    </el-form-item>
                    <el-form-item label="封面" v-if="info.double">
                        <el-upload
                            class="avatar-uploader"
                            action="/api/admin/uploadimage"
                            :on-success="handleAvatarSuccess2"
                            :show-file-list="false">
                                <img v-if="info.list[1].image!=null&&info.list[1].image!=''" :src="info.list[1].image" referrerpolicy="no-referrer" class="avatar">
                                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                        </el-upload>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" @click="onSubmit">保存</el-button>
                        <el-button @click="show=false">取消</el-button>
                    </el-form-item>
                </el-form>
            </div>
        </el-dialog>

    </div>
</template>

<script>
import {post,get} from "../axios/request.js"
export default {
  name:"order",
  data() {
    return {
      type:0,
      type1:0,
      type2:0,
      typelist:['杂谈','歌回','游戏回','水友回','DD歌回','联动回','二创回','其他'],
      info:{
        double:false,
        list:[
            {
                status:0,
                data:"",
                time:"",
                image:""
            },
            {
                status:0,
                data:"",
                time:"",
                image:""
            }
        ]
      },
      list:[],
      show:false,
      date:[],
      isLiving:false,
    }
  },
  mounted() {
	this.getmore();
  },
  methods: {
    onSubmit(){
        this.show=false;
        var date = {
            id:0,
            y:parseInt(this.info.date.split("/")[0]),
            m:parseInt(this.info.date.split("/")[1]),
            d:parseInt(this.info.date.split("/")[2].split(" ")[0]),
            status:-1,
            type:0,
            title:null,
            data:"",
            time:"",
            image:""
        }
        if(this.info.list[0].data.replace("\r","")==''&&this.type>=2){
            this.$message.error("请填写第一场直播的标题")
            return
        }
        if(this.info.list[0].time.replace("\r","")==''&&this.type>=2){
            this.$message.error("请填写第一场直播的时间")
            return;
        }
        if(this.type==1){
            date.status=0
        }else if(this.type==2){
            date.status=1;
            date.data=this.info.list[0].data.replace("\r","");
            date.time=this.info.list[0].time.replace("\r","");
            date.image=this.info.list[0].image.replace("\r","");
            date.type=this.type1;
            date.title=null;
        }else if(this.type==3){
            if(this.info.list[1].data.replace("\r","")==''){
                this.$message.error("请填写第二场直播的标题")
                return;
            }
            if(this.info.list[1].time.replace("\r","")==''){
                this.$message.error("请填写第二场直播的时间")
                return;
            }
            date.status=1;
            date.type=(this.type1+','+this.type2);
            date.data=this.info.list[0].data.replace("\r","");
            date.time=this.info.list[0].time.replace("\r","");
            date.image=this.info.list[0].image.replace("\r","");
            date.data+=('\n'+this.info.list[1].data.replace("\r",""))
            date.time+=('\n'+this.info.list[1].time.replace("\r",""))
            if(this.info.list[1].image!=null&&this.info.list[1].image!='')
                date.image+=(';'+this.info.list[1].image.replace("\r",""))
            date.title=this.typelist[this.type1]+','+this.typelist[this.type2];
        }
        date.id=this.info.id;
        post("/api/admin/updatedate",date).then((res)=>{
            if(res.data.code==1001){
                this.show=false;
                this.getmore();
                this.$notify({
                    title: '保存成功',
                    type: 'success'
                });
            }else{
                this.$notify({
                    title: '系统错误',
                    type: 'error'
                });
            }
        })
    },
    change(e){
        if(e==0){
            this.info.type=-1
            this.info.double=false;
        }
        if(e==1){
            this.info.type=0
            this.info.double=false;
        }
        if(e==2){
            this.info.type=1
            this.info.double=false;
        }
        if(e==3){
            this.info.type=1
            this.info.double=true;
        }
    },
    handleAvatarSuccess1(e){
        this.info.list[0].image=e.url;
    },
    handleAvatarSuccess2(e){
        this.info.list[1].image=e.url;  
    },
    update1(e){
        var date = JSON.parse(JSON.stringify(e));
        this.info.date=date.date;
        this.info.id=date.id;
        if(date.status==-1){
            this.type=0
            this.type1=0
            this.type2=0
            this.show=true;
        }
        else if(date.status==0){
                this.info.type=date.type;
                this.type=1
                this.type1=0
                this.type2=0
                this.show=true;
        }else{
                if(date.data!=null&&date.data.indexOf("\n")!=-1){
                    this.info.double=true;
                    this.type=3
                    this.type1=parseInt(date.type.split(",")[0]);
                    this.type2=parseInt(date.type.split(",")[1]);
                    this.info.list[0].data=date.data.split("\n")[0]
                    this.info.list[1].data=date.data.split("\n")[1]
                    this.info.list[0].time=date.time.split("\n")[0]
                    this.info.list[1].time=date.time.split("\n")[1]
                    this.info.list[0].image=date.image.split(";")[0]
                    this.info.list[1].image=date.image.split(";")[1]
                    this.info.list[0].type=date.type.split(",")[0];
                    this.info.list[1].type=date.type.split(",")[0];
                }else{
                    this.info.type=date.type;
                    this.info.double=false;
                    this.type1=parseInt(date.type);
                    this.type2=0
                    this.type=2
                    this.info.list[0].data=date.data.split("\n")[0]
                    this.info.list[0].time=date.time.split("\n")[0]
                    this.info.list[0].image=date.image.split(";")[0]
                }
        }
        this.info.date=date.date+' '+date.week;
        this.show=true;
    },
    gettype(e){
				e=JSON.parse(JSON.stringify(e))
				//type 0:杂谈 1:歌回 2:游戏回 3:水友回 4:DD歌回 5:联动回 6:二创回 7:其他
				if(typeof(e)=='string'){
					e=parseInt(e.split(",")[0])
				}
				if(e==-1)return'全部'
				if(e==0)return'杂谈'
				if(e==1)return'歌回'
				if(e==2)return'游戏回'
				if(e==3)return'水友回'
				if(e==4)return'DD歌回'
				if(e==5)return'联动回'
				if(e==6)return'二创回'
				if(e==7)return'其他'
			},
			getcolor(i,e){
				e=JSON.parse(JSON.stringify(e))
				if(typeof(e)=='string'){
					e=parseInt(e.split(",")[0])
				}
				if(i==0)return 'linear-gradient(to right,rgba(177, 171, 255, 0.4),rgba(177, 171, 255, 0.05))'
				if(i==-1)return 'linear-gradient(to right,rgba(239,239,239,0.8),rgba(239,239,239,0.8))'
				if(e==0)return 'linear-gradient(to right,rgba(255, 170, 255, 0.4),rgba(255, 170, 255, 0.05)'
				if(e==1)return 'linear-gradient(to right,rgba(166, 57, 255, 0.4),rgba(166, 57, 255, 0.05))'
				if(e==2)return 'linear-gradient(to right,rgba(85,170,255,0.4),rgba(85,170,255,0.05))'
				if(e==3)return 'linear-gradient(to right,rgba(85,255,255,0.4),rgba(85,255,255,0.05))'
				if(e==4)return 'linear-gradient(to right,rgba(255,85,0,0.4),rgba(255,85,0,0.05))'
				if(e==5)return 'linear-gradient(to right,rgba(139, 0, 0, 0.4),rgba(139, 0, 0, 0.05))'
				if(e==6)return 'linear-gradient(to right,rgba(255, 170, 0, 0.4),rgba(255, 170, 0, 0.05))'
				if(e==7)return 'linear-gradient(to right,rgba(107, 212, 200, 0.4),rgba(107, 212, 200, 0.05))'
				
			},
            juge2(e){
				if(typeof(e)=='string'){
					if(e.indexOf(',')!=-1)return true;return false
				}
				else return false
			},
			juge1(){
				if(this.type==-1)return 0;
				
				return 7-(this.typelist[this.type]%7)
			},
            juge(y,m,d){
				var date = y
				if(m<10)date+=('/0'+m)
				else date+=('/'+m)
				if(d<10)date+=('/0'+d)
				else date+=('/'+d)
				return date
			},
			gettype1(e){
				e=JSON.parse(JSON.stringify(e))
					if(this.type==-1)return '#6e5bd8'
					if(this.type==0)return '#9e2d73'
					if(this.type==1)return '#7400da'
					if(this.type==2)return '#326699'
					if(this.type==3)return '#287a7a'
					if(this.type==4)return '#d64700'
					if(this.type==5)return '#550000'
					if(this.type==6)return '#b67900'
					if(this.type==7)return '#069e8c'
			},
			getcolor1(i,e){
				e=JSON.parse(JSON.stringify(e))
				if(typeof(e)=='string'){
					e=parseInt(e.split(",")[0])
				}
				if(i==-1)return '#606266'
				if(i==0)return '#6e5bd8'
				if(e==0)return '#9e2d73'
				if(e==1)return '#7400da'
				if(e==2)return '#326699'
				if(e==3)return '#287a7a'
				if(e==4)return '#d64700'
				if(e==5)return '#550000'
				if(e==6)return '#b67900'
				if(e==7)return '#069e8c'
			},
    generateCurrentMonthDates(){
        const dateArray = [];
			  const today = new Date();
			  today.setHours(0, 0, 0, 0); // 清除时间部分，仅保留日期
			
			  // ===================== 1. 确定关键时间点 =====================
			  // 固定起始日期：2025年9月1日（月份0-11，故9月用8表示）
			  const startDate = new Date(2025, 8, 1);
			  startDate.setHours(0, 0, 0, 0);
			
			  // 本周的周末（周日）：延续原逻辑（周一到周日为一周）
			  const weekStart = new Date(today);
			  const weekDay = today.getDay() || 7; // 周日的getDay()为0，转为7
			  weekStart.setDate(today.getDate() - (weekDay - 1)); // 本周一
			  weekStart.setHours(0, 0, 0, 0);
			  const weekEnd = new Date(weekStart);
			  weekEnd.setDate(weekStart.getDate() + 6); // 本周日（周末）
			  weekEnd.setHours(23, 59, 59, 999); // 周末当天的结束时间
			
			  // 边界处理：若起始日期晚于周末（理论上2025/09后使用，暂提示兼容）
			  if (startDate > weekEnd) {
			  
			    return dateArray;
			  }
			
			  // ===================== 2. 生成日期数组（2025/09/01 至 本周日） =====================
			  const weekMap = ['星期日', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六'];
			  let currentDate = new Date(startDate); // 从起始日期开始遍历
			
			  while (currentDate <= weekEnd) {
			    // 计算日期状态：大于今天且不在本周内 → status=-1（不可选），否则0（可选）
			    let status = 0;
			    if (currentDate >= today) {
				
			      if ((currentDate >= weekStart && currentDate <= weekEnd)) {
			        status = -1;
			      }
			    }
			
			    // 格式化日期（两位数年份/月份/日期）
			    const year = currentDate.getFullYear();
			    const shortYear = String(year).slice(-2);
			    const formattedMonth = String(currentDate.getMonth() + 1).padStart(2, '0');
			    const formattedDay = String(currentDate.getDate()).padStart(2, '0');
			
			    // 组装日期对象（保留原结构）
			    const dateItem = {
			      date: `${shortYear}/${formattedMonth}/${formattedDay}`,
			      week: weekMap[currentDate.getDay()], // 对应中文星期
			      status: status,
			      type: -1,
			      data: "",
			      frame:(currentDate.getFullYear() === today.getFullYear() &&  currentDate.getMonth() === today.getMonth() && currentDate.getDate() === today.getDate()) // 当天日期标红/高亮标识
			    };
			
			    dateArray.push(dateItem);
			    // 日期+1，继续遍历下一天
			    currentDate.setDate(currentDate.getDate() + 1);
			  }
			
			  // ===================== 3. 数组倒序（从本周周末倒推至2025/09/01） =====================
			  dateArray.reverse();
			
			  return dateArray;
    },
    getmore(){
        this.list = this.generateCurrentMonthDates();
        post("/api/getdate",{}).then((res)=>{
        this.date=res.data.data;
		for(var x=0;x<this.date.length;x++){
			for(var y=0;y<this.list.length;y++)
				if(this.juge(this.date[x].y,this.date[x].m,this.date[x].d)==this.list[y].date){
					this.list[y].status=this.date[x].status
					this.list[y].type=this.date[x].type
					this.list[y].data=this.date[x].data
					this.list[y].image=this.date[x].image
					this.list[y].time=this.date[x].time
					this.list[y].url=this.date[x].url
					this.list[y].title=this.date[x].title
                    this.list[y].id=this.date[x].id
				}
		}
    })
    },
    getimage(e){
		e=JSON.parse(JSON.stringify(e))
		if(e.image!=null&&e.image!='')return e.image;
		if(typeof(e.type)=='string'){
			e.type=parseInt(e.type.split(",")[0])
		}
		if(e.status==-1)return 'https://image.begonia.cafe/tx/new/wait.webp'
		if(e.status==0)return 'https://image.begonia.cafe/tx/new/sleep.webp'
		if(e.type==0)return 'https://image.begonia.cafe/tx/new/CBAE07F605E0676868DD7E3F12202F7E.jpg'
		if(e.type==1)return 'https://image.begonia.cafe/tx/new/image6.webp'
		if(e.type==4)return 'https://image.begonia.cafe/tx/new/image4.webp'
		if(e.type==5)return 'https://image.begonia.cafe/tx/new/image5.webp'
		if(e.type==6)return 'https://image.begonia.cafe/tx/new/title.webp'
		return e.image
	},
  }
}
</script>
<style scoped>
::v-deep .isdisabled  {
	background-color: white;
}
.el-upload {
    border: 0.5px solid #efefef;
  }
 .avatar-uploader .el-upload {
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    border: 0.5px solid #efefef;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 150px;
    height: 100px;
    line-height: 100px;
    p-align: center;
  }
  .avatar {
    width: 150px;
    height: 150px;
    display: block;
  }
  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 150px;
    height: 100px;
    line-height: 100px;
    text-align: center;
  }
  .avatar {
    width: 150px;
    height: 100px;
    display: block;
    object-fit: cover;
  }
</style>
